import React from 'react'
import { SuggestionProps } from '../../others/accomodation.interfaces'
import { repeat } from '../../others/oneliners'
import AccomodationCard from './AccomodationCard'
import { AccomodationCardSkeleton } from './AccomodationCard'

interface AccomodationSliderProps extends SuggestionProps {
    title: string;
    subtitle: string;
}

const Suggestions = ({ suggestions, title, subtitle }: AccomodationSliderProps) => {
    return (
        <div className='mb-0 pt-5 pb-1 px-5 lg:px-20'>
            <h2 className='font-black'>{title}</h2>
            <p className='text-gray-500 -mt-1'>{subtitle}</p>
            {/* <div className='grid grid-cols-1 2xs:grid-cols-2 md:!grid-cols-3 lg:!grid-cols-4 gap-7'> */}
            <div className='mt-8 flex gap-7 overflow-x-scroll no-scrollbar'>
                {
                    !suggestions
                        ?
                        <>
                            {
                                repeat<object>([], 5).map((skeleton, i) => {
                                    return <AccomodationCardSkeleton huge={false} key={'accomodation-skeleton-' + i} />
                                })
                            }
                        </>
                        :
                        <>
                            {
                                suggestions.map((accomodation, i: number) => {
                                    return <AccomodationCard {...accomodation} key={`accomodationCard-${i}`} />
                                })
                            }
                        </>
                }
            </div>
        </div>
    )
}

export default Suggestions